import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyActiveDonation
} from "../../DashBoardView/slice";


const Statsbox = ({ item, t , myActiveDonations}) => {
  const {
    auth: { profile },
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const [myDonations, setMyDonations] = React.useState(null);
  const [doacoesCount, setDoacoesCount] = React.useState(null);
  const [eventosCount, setEventosCount] = React.useState(null);
  const [ReservasCount, setReservasCount] = React.useState(null);
  const [RecolhidasCount, setRecolhidasCount] = React.useState(null);

  React.useEffect(() => {  
    let payload = {entityId : profile.entity.entityId ,
                  entityType : 'DONOR'}

    dispatch(getMyActiveDonation(payload))
    .unwrap()
    .then((res) => {
      setMyDonations(res ? res.donationDetails : null);
      //console.log(payload , res , "TRY DONATIONS")
    })
   
  }, [profile]);

  React.useEffect(() => {
    var reservations = 0;
    if(myDonations != null) {status: 'COLLECTED'
      setDoacoesCount(myDonations.filter((item, index) => item.donation.isEvent === false && item.donation.status != 'COLLECTED'))
      setEventosCount(myDonations.filter((item, index) => item.donation.isEvent === true ))
      setRecolhidasCount(myDonations.filter((item, index) => item.donation.status == 'COLLECTED'))

      {myDonations?.map((item, index) => (
        reservations = reservations + item.collectionCount 
      ))}
      setReservasCount(reservations);
    }
   
    
  }, [myDonations]);


  return (
    <Paper
      sx={{
        padding: "10px",
        margin: "10px",
      }}
      elevation={10}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <SvgIconStyle
          src={item.icon}
          sx={{ color: "#7AB5BD", width: "31px", height: "32px" }}
        />
        {/* <Typography
          fontSize={"small"}
          fontWeight={"bold"}
          color={item.growthRate.includes("-") ? "red" : "green"}
        >
          {item.growthRate}
          {item.growthRate.includes("-") ? (
            <SvgIconStyle
              src={"/static/dashboard/growthDown.svg"}
              sx={{
                color: "#6FBE42",
                width: "12px",
                height: "12px",
                marginLeft: "5px",
              }}
            />
          ) : (
            <SvgIconStyle
              src={"/static/dashboard/growthup.svg"}
              sx={{
                color: "#6FBE42",
                width: "12px",
                height: "12px",
                marginLeft: "5px",
              }}
            />
          )}
        </Typography> */}
      </Box>
      <Typography 
        variant="h2"
        style={{
          fontSize: "32px",
          fontWeight: "bold"
        }}
        >
        {/* {item.number} */}
        {item.title == 'Doações' ? doacoesCount != null ? doacoesCount.length : 0 
        : item.title == 'Eventos' ? eventosCount != null ? eventosCount.length : 0 
        : item.title == 'Reservadas' ? ReservasCount != null ? ReservasCount : 0
        : item.title == 'Recolhidas' ? RecolhidasCount != null ? RecolhidasCount.length : 0
        : item.number}

      </Typography>
      <Typography fontSize={"16px"}>{t(item.title)}</Typography>
    </Paper>
  );
};

export default Statsbox;
